module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_02B.1f804bcc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_02B.mp3
// module id = 104
// module chunks = 0